const _minute = 1000 * 60;

class CheckoutCountdown {
    constructor(el) {

        this.el = el;
        this.stage = el.querySelector('.stage');

        // parse deadline
        this.timeout = parseInt(el.dataset.timeout, 10) * 1000;
        this.redirectUrl = el.dataset.redirectUrl;

        // create web worker to handle the timing
        let _this = this;
        if (typeof(Worker)!=="undefined"){
            this.w = new Worker(new URL("./checkout-time-remaining--worker.js", import.meta.url));
            this.w.postMessage(this.timeout);
            // listen for messages
            this.w.onmessage = (e) => {
                _this.timeout = parseInt(e.data);
                _this.update();
            };

        }
    }

    update() {

        // update countdown or show finish message
        if (this.timeout > 0) {
            // calc remaining minutes
            let minutesRemaining = Math.floor(this.timeout / _minute);
            // calc remaining seconds
            let secondsRemaining = Math.floor((this.timeout % _minute) / 1000);
            // create countdown message
            let message = 'Your order is reserved for';
            if (minutesRemaining > 1) {
                message += ' ' + minutesRemaining + ' <abbr title="minutes">mins</abbr>';
            } else if (minutesRemaining == 1) {
                message += ' 1 <abbr title="minute">min</abbr>';
            }
            if (secondsRemaining == 1) {
                message += ' 1 <abbr title="second">sec</abbr>.';
            } else {
                message += ' ' + secondsRemaining + ' <abbr title="seconds">secs</abbr>.';
            }
            this.stage.innerHTML = message;
        } else {
            // finish message
            this.stage.innerHTML = 'Your order reservation has timed out. Please refresh and start again.';
            this.w.terminate();
            window.location = this.redirectUrl;
        }
    }

}

// create countdown
const obj = document.querySelector('#checkout-time-remaining');
new CheckoutCountdown(obj);
